<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex ">
      <dark-Toggler class="d-none d-lg-block" />
      <h4> ระบบจองคิวแรงงานต่างด้าว
      </h4>

    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown right toggle-class="d-flex align-items-center dropdown-user-link" class="dropdown-user">
        <!-- {{jwt}} -->
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              <!-- {{jwt.userId}} John Doe -->
            </p>

            <span class="user-status text-uppercase">{{ jwt.role }}</span>
          </div>
          <!-- <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="require('@/assets/images/avatars/13-small.png')"
            class="badge-minimal"
            badge-variant="success"
          /> -->
          <b-avatar size="40" variant="light-primary" badge class="badge-minimal" badge-variant="success" />
        </template>

        <!-- <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>Profile</span>
        </b-dropdown-item> -->
        <!-- 
        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="MailIcon"
            class="mr-50"
          />
          <span>Inbox</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="CheckSquareIcon"
            class="mr-50"
          />
          <span>Task</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="MessageSquareIcon"
            class="mr-50"
          />
          <span>Chat</span>
        </b-dropdown-item> -->

        <b-dropdown-divider />

        <b-dropdown-item link-class="d-flex align-items-center" @click="logOut()">
          <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
          <span>ออกจากระบบ</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import store from "@/store/index";
import jwt from '@/auth/jwt/useJwt';

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,

    // Navbar Components
    DarkToggler,
  },
  data() {
    return {
      perPage: 100,
      jwt: JSON.parse(localStorage.getItem("company_jwt")) || null,
      // jwt: jwt.getJwt() || null, // If you are using a JWT plugin
      // jwt: store.state.auth.jwt || null, // If you are using Vuex for state management
      menuData: [ // ตัวอย่างเมนู ถ้าเมนูมาจากไฟล์ import ให้แก้ตามนั้น
        {
          title: 'Dashboard',
          route: 'dashboard',
          roles: ['admin'],
        },
        {
          title: 'รายงานการชำระเงิน',
          route: 'paymentreport',
          roles: ['staff'],
        },
        // ถ้ามีเมนูย่อย ใช้ children แบบนี้
        /*
        {
          title: 'เมนูหลัก',
          roles: ['admin', 'staff'],
          children: [
            { title: 'เมนูย่อย 1', route: 'sub1', roles: ['admin'] },
            { title: 'เมนูย่อย 2', route: 'sub2', roles: ['staff'] },
          ]
        }
        */
      ],
    };
  },
  computed: {
    filteredMenu() {
      const userRole = localStorage.getItem('role') || ''

      return this.menuData
        .map(section => {
          if (!section.children) return section

          // กรอง children ตาม role
          const filteredChildren = section.children.filter(child => {
            if (!child.roles) return true
            return child.roles.includes(userRole)
          })

          // คืนค่าที่มี children ที่กรองแล้ว
          return {
            ...section,
            children: filteredChildren
          }
        })
        // กรอง section ที่ไม่มี children เหลือเลย (ถ้ามี children)
        .filter(section => !section.children || section.children.length > 0)
    }
  },
  // created() {
  //        const jwt = JSON.parse(localStorage.getItem("company_jwt"));
  //   console.log(jwt);
  // },
  methods: {
    async logOut() {
      //   const refresh_token = JSON.parse(localStorage.getItem('refresh_token'));
      const res = await store.dispatch("IN_AUTHORIZATION");
      console.log(res);
      //     return
      if (res == "Logout Successfully") {
        this.$router.push({ name: "login" });
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `${res}`,
            icon: "EditIcon",
            variant: "danger",
          },
        });
      }
    },
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => { },
    },
  },
}
</script>
